import { getEbookCatalogue } from 'lib/api/ebook';
import { useQuery } from '@tanstack/react-query';
import Card from './Card';

import { SMainContainer } from './styled';
import { DATA_CY_EBOOK_MAIN_COMPONENT } from '../__tests__/constant';

const Main = ({ isPaneActive }) => {
  const { data: ebookCatalogue } = useQuery({
    queryKey: ['getCatalogue'],
    queryFn: getEbookCatalogue,
  });

  return (
    <SMainContainer data-cy={DATA_CY_EBOOK_MAIN_COMPONENT}>
      {ebookCatalogue?.data?.data?.map((book) => (
        <Card
          key={book.alias}
          bookName={book.name}
          imageName={book.image}
          alias={book.alias}
          isPaneActive={isPaneActive}
        />
      ))}
    </SMainContainer>
  );
};

export default Main;
